import { z } from 'zod';
import LangEnum from '../../../../lang/LangEnum';
import { TranslateType } from '../../../translation/translationContext.types';

export const buildCreateContextLoginSchema = (translate: TranslateType) =>
  z.object({
    username: z
      .string()
      .trim()
      .min(1, translate(LangEnum.GLOBAL_REQUIRED))
      .pipe(z.email(translate(LangEnum.GLOBAL_INVALID_EMAIL))),
    password: z.string().trim().min(1, translate(LangEnum.GLOBAL_REQUIRED)),
  });

export type CreateContextLoginFormValues = z.infer<
  ReturnType<typeof buildCreateContextLoginSchema>
>;
